// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"1168e24fbac17bff64cd","524":"af0c078005ec0c8a2c7d","708":"fd0e9c6ed240a71a2e0c"}[chunkId] + ".css";
};